import axios from "axios";
import { toast } from "react-toastify";

const imageBasePath = "https://tezbikes.com/tezbike/assets"

const UploadImage = async (file, token, navigate) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("upload_file", file);

    try {
        const response = await axios.post(
            "https://tezbikes.com/tezbike/api/v1/I8JLS9KH9/admin/upload.php",
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        const result = response.data.status;

        if (response.status === 401 || response.status === 400 || result.code === 401) {
            toast.error(result.message || "Unauthorized. Please log in again.");
            navigate("/login");
        } else if (result.code === 404) {
            toast.error(result.message || "File not found. Please try again.");
            throw new Error(result.message);
        } else if (result.code === 500) {
            toast.error("Something went wrong. Please try again.");
            navigate("/500");
        }

        if (response.data.status === "1") {
            const uploadedLogoUrl = response.data.data;
            return uploadedLogoUrl;
        } else {
            toast.error(result.message || "Failed to upload image.");
        }
    } catch (error) {
        console.error("Upload Error:", error);
        toast.error("An error occurred while uploading the image.");
    }
};


export {
    UploadImage
}